import { combineReducers } from "redux";
import { IAction } from "../interfaces/action.interface";
import { authReducer, IAuthReducer } from "./auth";
import { IPreferencesReducer, preferencesReducer } from "./preferences";
import { IUserReducer, userReducer } from "./user";

export interface IRootReducer {
    default: IDefaultReducer,
    auth: IAuthReducer,
    user: IUserReducer,
    preferences: IPreferencesReducer,
}

interface IDefaultReducer {}

const initialState : IDefaultReducer = {};

const defaultReducer = (state:IDefaultReducer=initialState, action:IAction) : IDefaultReducer => {
    switch(action.type) {
        default: {
            return state; 
        }
    }
};

const reducers = combineReducers({
    default: defaultReducer,
    preferences: preferencesReducer,
    auth: authReducer,
    user: userReducer,
});

export { reducers };